import { useEffect } from 'react'
import { useRegisterSW } from 'virtual:pwa-register/react'

/**
 * « Nouvelle version disponible » (S72, demande Enzo : « comme le BO, pouvoir
 * mettre a jour directement plutot que retirer et remettre l'application »).
 *
 * Le service worker est enregistre en mode `prompt` (vite.config.js) : quand un
 * nouveau bundle est deploye, il s'installe et ATTEND. Ce bandeau le dit et
 * « Mettre a jour » lui donne la main (`skipWaiting` + rechargement). On
 * verifie une mise a jour toutes les 5 minutes et a chaque retour sur l'app —
 * une PWA installee ne « navigue » jamais, sans cela elle ne verrait rien.
 */
const INTERVALLE_VERIF = 5 * 60 * 1000

export default function MiseAJourBanner() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_url, registration) {
      if (!registration) return
      const verifier = () => { registration.update().catch(() => {}) }
      const timer = setInterval(verifier, INTERVALLE_VERIF)
      const surRetour = () => { if (document.visibilityState === 'visible') verifier() }
      document.addEventListener('visibilitychange', surRetour)
      window.addEventListener('focus', surRetour)
      // Pas de demontage : ce composant vit toute la vie de l'app.
      void timer
    },
  })

  useEffect(() => {
    if (needRefresh) console.info('[pwa] nouvelle version prete — bandeau affiche')
  }, [needRefresh])

  if (!needRefresh) return null

  return (
    <div
      role="status"
      // Pas de `translate-x` : `animate-fade-up` pose son propre `transform`
      // (fill forwards) et ecraserait le centrage — marges auto a la place.
      className="glass-dark fixed z-[120] flex items-center gap-3 rounded-2xl px-4 py-3 animate-fade-up"
      style={{ bottom: 'calc(max(20px, env(safe-area-inset-bottom)) + 84px)', left: 16, right: 16, maxWidth: 420, margin: '0 auto', color: 'rgb(var(--c-creme))' }}
    >
      <span className="text-xl leading-none">🆕</span>
      <div className="flex-1 min-w-0">
        <p className="text-[13px] font-bold leading-tight">Nouvelle version disponible</p>
        <p className="text-[10.5px] leading-tight mt-0.5" style={{ opacity: 0.75 }}>Touchez pour recharger l'application.</p>
      </div>
      <button
        onClick={() => updateServiceWorker(true)}
        className="rounded-full px-3.5 py-2 text-[12px] font-extrabold flex-shrink-0"
        style={{ background: 'rgb(var(--c-creme))', color: 'rgb(var(--c-green))' }}
      >
        Mettre à jour
      </button>
    </div>
  )
}
